import Checkbox from '@/components/ui/Checkbox';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { OWNER_EMAIL_NAME } from '@/features/v2/summaryForms/components/InputEmail';
import { OWNER_FIRST_NAME_NAME } from '@/features/v2/summaryForms/components/InputFirstName';
import { OWNER_LAST_NAME_NAME } from '@/features/v2/summaryForms/components/InputLastName';
import { OWNER_PHONE_NAME } from '@/features/v2/summaryForms/components/InputPhone';

import { i18n } from '@lingui/core';
import { useFormContext } from 'react-hook-form';

export const OWNER_ACCOUNT_IS_OWNER_NAME = 'owner.account_is_owner';

const CheckboxAccountIsOwner = ({
  name = OWNER_ACCOUNT_IS_OWNER_NAME,
  label = i18n.t(
    'Jestem właścicielem pojazdu wpisanym do dowodu rejestracyjnego'
  ),
  accountPhoneValue,
  accountEmailValue,
  accountFirstNameValue,
  accountLastNameValue,
}: {
  name?: string;
  label?: string;
  accountPhoneValue: string;
  accountEmailValue: string;
  accountFirstNameValue: string;
  accountLastNameValue: string;
}) => {
  const { setValue, trigger, clearErrors } = useFormContext();

  return (
    <FormField
      name={name}
      defaultValue={true}
      render={({ field }) => {
        const { value, onChange, onBlur, ...restField } = field;
        return (
          <FormItem className="col-span-4 md:col-span-4">
            <FormControl>
              <Checkbox
                variant={'filled'}
                label={label}
                value={value}
                defaultChecked={value}
                className="p-[14px] outline-dark-gray-200 lg:p-4"
                onCheckedChange={(check) => {
                  onChange(check);
                  if (check) {
                    clearErrors(OWNER_PHONE_NAME);
                    clearErrors(OWNER_EMAIL_NAME);
                    setValue(OWNER_PHONE_NAME, accountPhoneValue);
                    setValue(OWNER_EMAIL_NAME, accountEmailValue);
                    setValue(OWNER_FIRST_NAME_NAME, accountFirstNameValue);
                    trigger(OWNER_FIRST_NAME_NAME);
                    setValue(OWNER_LAST_NAME_NAME, accountLastNameValue);
                    accountLastNameValue && trigger(OWNER_LAST_NAME_NAME);
                  }
                  if (!check) {
                    clearErrors(OWNER_LAST_NAME_NAME);
                    setValue(OWNER_PHONE_NAME, '');
                    setValue(OWNER_EMAIL_NAME, '');
                    setValue(OWNER_FIRST_NAME_NAME, '');
                    setValue(OWNER_LAST_NAME_NAME, '');
                  }
                }}
                onBlur={onBlur}
                {...restField}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default CheckboxAccountIsOwner;
